import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Form, Button, Container } from "react-bootstrap";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const EditPayment = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [accounts, setAccounts] = useState([]);
    const [cashAccounts, setCashAccounts] = useState([]);
    const [payment, setPayment] = useState({
        date: "",
        payment_number: "",
        from_account: "",
        to_account: "",
        from_account_id: "",
        to_account_id: "",
        amount: "",
        description: "",
    });

    useEffect(() => {
        fetchPayment();
        fetchAccounts();
        fetchCashAccounts();
    }, []);

    const fetchPayment = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-one-payment?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPayment(response.data.payment);
        } catch (error) {
            console.error("Error fetching payment:", error);
        }
    };

    const fetchAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-accounts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    };

    const fetchCashAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}get-accounts`,
                { account_type_ids: [9, 10] },
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            setCashAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching cash accounts:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        const payload = {
            payment_id: id,  
            from_account_id: payment.from_account_id,
            to_account_id: payment.to_account_id,
            amount: parseFloat(payment.amount), 
            date: payment.date,
            description: payment.description || "", 
        };
    
        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}update-payment`, payload, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
    
            alert(response.data.message || "Payment updated successfully!");
            navigate("/payment-list");
        } catch (error) {
            console.error("Error updating payment:", error);
            alert(error.response?.data?.message || "Error updating payment. Please try again.");
        }
    };
    
    return (
        <Layout>
            <h4>Edit Payment</h4>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-2">
                    <Form.Label>Date</Form.Label>
                    <Form.Control type="date" name="date" value={payment.date} onChange={(e) => setPayment({ ...payment, date: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>From Account</Form.Label>
                    <Form.Select value={payment.from_account_id} onChange={(e) => setPayment({ ...payment, from_account_id: e.target.value })}>
                        <option value="">Select an account</option>
                        {cashAccounts.map(account => (
                            <option key={account.id} value={account.id}>{account.name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>To Account</Form.Label>
                    <Form.Select value={payment.to_account_id} onChange={(e) => setPayment({ ...payment, to_account_id: e.target.value })}>
                        <option value="">Select an account</option>
                        {accounts.map(account => (
                            <option key={account.id} value={account.id}>{account.name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control type="number" name="amount" value={payment.amount} onChange={(e) => setPayment({ ...payment, amount: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text" name="description" value={payment.description} onChange={(e) => setPayment({ ...payment, description: e.target.value })} />
                </Form.Group>

                <Button type="submit" variant="primary">Update Payment</Button>
                <Button variant="secondary" className="ms-2" onClick={() => navigate(-1)}>Cancel</Button>
            </Form>
        </Layout>
    );
};

export default EditPayment;
